import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { colorPalette } from '@shared/config/colorsConfig';

export interface CustomRadioProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  size?: number;
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 24,
}) => {
  const handlePress = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <TouchableOpacity
      onPress={handlePress}
      disabled={disabled}
      activeOpacity={0.7}
      accessibilityRole="radio"
      accessibilityState={{ checked, disabled }}
      style={[
        styles.container,
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          borderColor: checked ? colorPalette.secondary[600] : colorPalette.gray[300],
          backgroundColor: checked ? colorPalette.secondary[600] : colorPalette.white,
        },
        disabled && styles.disabled,
      ]}
    >
      {checked && (
        <View
          style={[
            styles.inner,
            {
              width: size * 0.32,
              height: size * 0.32,
              borderRadius: (size * 0.32) / 2,
              backgroundColor: colorPalette.white,
            },
          ]}
        />
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
  },
  inner: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.5,
  },
});

export default CustomRadio;